import { poTemplateSchema } from "@redotech/redo-fulfillment-operations-common/purchase-order-document";
import * as z from "zod";

export const getPoTemplate = {
  name: "getPoTemplate" as const,
  input: z.object({ templateId: z.string() }),
  output: poTemplateSchema,
};
